<app-breadcrumb  *ngIf="!mod" [master]="'Administracja'" [parentName]="'Słownik'" [name]="'Dodaj'"></app-breadcrumb>
<div class="tags-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
    <button   [disabled]="!dictFormValid ||processingRequest " [class.spinner]="processingRequest" (click)="sendForm()" mat-stroked-button color="primary" >  <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" *ngIf="!mod">
            <h3>Dodawanie Wartości</h3>
          </div>

          <div fxLayout="row" *ngIf="mod">
            <h3>Edytuj Wartości</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa </mat-label>

                <input [formControl]="nameControl" appCapitalizeFirst matInput placeholder="Nazwa "  [required]="true" >
                <mat-error *ngIf="dynamicDictionaryForm.get('name').hasError('backendError')">{{errors.name}}</mat-error>

              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px"  *ngIf="!mod">

            <div fxFlex="100">


              <app-dict
                [label]="'Typ '" [dictType]="'dynamic_dictionary'"
                [required]="true"
                [multiple]="false"
                [autoSelect]="false"
                [formControl]="typeControl"
              ></app-dict>


            </div>

          </div>

        </mat-card>
      </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button   [disabled]="!dictFormValid ||processingRequest " [class.spinner]="processingRequest"(click)="sendForm()" mat-stroked-button color="primary" >
      <mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>
</div>

